import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { IFormSection, TFormHookParams } from "../../types/common";
import { API_WAGE_ADVANCEMENTS } from "../../utils/apis";
import {
  getRegister,
  objectWithUnsetKeys,
  prepareAttachmentsPost,
} from "../../utils/helpers";
import { URL_WAGE_ADVANCEMENTS } from "../../utils/urls";
import { ATTACHMENTS, FORM_DATA } from "../../utils/constants";

export const useWageAdvancementsForm = ({
  updateFormValues,
}: TFormHookParams = {}) => {
  const location = useLocation();
  const itemData = location.state?.item;

  useEffect(() => {
    if (itemData) {
      updateFormValues?.({
        user: itemData.user,
        user_name: itemData.user_name,
        current_fixed_wage: itemData.fixed_wage,
      });
    }
  }, [itemData]);

  const sections: IFormSection[] = useMemo(
    () => [
      {
        title: "Advance Request",
        fields: [
          {
            field_name: "user_name",
            label: "User",
            type: "text",
            props: {
              disabled: true,
              placeholder: "User",
            },
          },
          {
            field_name: "current_fixed_wage",
            label: "Current Fixed Wage",
            type: "number",
            props: {
              required: true,
              disabled: true,
              placeholder: "Current fixed wage",
            },
          },
          {
            field_name: "new_wage",
            label: "New Wage",
            type: "number",
            props: {
              required: true,
              min: 0,
              placeholder: "Enter new wage",
            },
          },
          {
            field_name: "amount",
            label: "Amount",
            type: "number",
            props: {
              required: true,
              min: 0,
              placeholder: "Enter amount",
            },
          },
          {
            field_name: "reason",
            label: "Reason",
            type: "textarea",
            props: {
              required: true,
              placeholder: "Enter reason for the advance",
            },
          },
          {
            field_name: "supporting_document",
            label: "Supporting Document",
            type: "file",
            props: {
              required: true,
              placeholder: "Upload supporting document",
              multiple: false,
            },
          },
        ],
      },
    ],
    [],
  );

  const title = "Request Advance";
  const redirect = getRegister(URL_WAGE_ADVANCEMENTS);

  const onSubmit = (payload: any) => {
    const attachments = [payload?.supporting_document];
    return {
      api: API_WAGE_ADVANCEMENTS,
      params: {
        ...objectWithUnsetKeys(payload, ["supporting_document", "user_name"]),
        ...prepareAttachmentsPost(attachments, ATTACHMENTS),
        user: itemData?.user ?? payload?.user,
        current_fixed_wage: itemData?.fixed_wage ?? payload?.current_fixed_wage,
      },
      type: FORM_DATA,
    };
  };

  return {
    sections,
    title,
    redirect,
    onSubmit,
    submitText: "Submit Request",
    itemData,
  };
};
